import { useId } from 'react';

const normalizeReactId = (value: string) => value.replace(/:/g, '');

export const joinAriaIds = (...ids: Array<string | undefined>) => {
  const joined = ids.filter(Boolean).join(' ');
  return joined || undefined;
};

export const useWxbFieldIds = (providedControlId?: string) => {
  const reactId = normalizeReactId(useId());
  const controlId = providedControlId || `wxb-field-${reactId}`;

  return {
    controlId,
    labelId: `${controlId}-label`,
    feedbackId: `${controlId}-feedback`,
  };
};
